export default __webpack_public_path__ + "static/media/code-pc.903d651a.gif";